import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './MobileCarousel.module.css';

const MobileCarousel = props => {
  const { rootClassName, className, children } = props;
  const classes = classNames(rootClassName || css.root, className);
  return <div className={classes}>{children}</div>;
};

MobileCarousel.defaultProps = {
  className: null,
  rootClassName: null,
};

MobileCarousel.propTypes = {
  className: string,
  rootClassName: string,
};

export default MobileCarousel;
